export const noop = (...args: unknown[]) => {}
